var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'members-avatars-group': true,
    'is-group': _vm.members.length > 1,
    'is-big': _vm.size > 50
  }},[(_vm.members.length > 0)?_c('member-avatar',{attrs:{"member":_vm.members[0],"size":_vm.size}}):_vm._e(),(_vm.members.length > 1)?_c('member-avatar',{attrs:{"member":_vm.members[1],"size":_vm.size}}):_vm._e(),(_vm.members.length > 2)?_c('span',{staticClass:"d-inline-block text-center member-count"},[_vm._v(" +"+_vm._s(_vm.members.length - 2)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }